import { assistantChatWithAgentFragment } from './fragmentsAssistantChat';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantChatCreateMutationAtom = createMutationAtomFactory(
  'assistant.chatCreate',
  (params?: { title?: string }) => ({
    assistantCreateChat: {
      __args: {
        input: {
          title: params?.title,
        },
      },
      ...assistantChatWithAgentFragment,
    },
  }),
);
